import {
  AppBar,
  Toolbar,
  Typography,
  IconButton,
  Box,
  Button
} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import { useLocation, useNavigate } from 'react-router-dom';
import { logout } from '../../services/authService';

const getPageTitle = (pathname: string) => {
  if (pathname.startsWith('/items')) return 'Items';
  if (pathname.startsWith('/categories')) return 'Categories';
  if (pathname.startsWith('/slider')) return 'Slider';
  if (pathname.startsWith('/about')) return 'About';
  if (pathname.startsWith('/contact')) return 'Contact Messages';
  if (pathname === '/') return 'Dashboard';
  return 'Admin';
};

export const TopBar = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/login', { replace: true });
  };

  return (
    <AppBar
      position="fixed"
      sx={{
        zIndex: (theme) => theme.zIndex.drawer + 1
      }}
    >
      <Toolbar>
        <IconButton
          color="inherit"
          edge="start"
          sx={{ mr: 2, display: { xs: 'inline-flex', sm: 'none' } }}
        >
          <MenuIcon />
        </IconButton>
        <Typography variant="h6" noWrap component="div">
          {getPageTitle(location.pathname)}
        </Typography>
        <Box sx={{ flexGrow: 1 }} />
        <Button color="inherit" onClick={handleLogout}>
          Logout
        </Button>
      </Toolbar>
    </AppBar>
  );
};

